// src/pages/RecordsPage.js
import { Outlet } from 'react-router-dom';
import RecordDetailProvider from '../features/records/contexts/RecordDetailProvider';

const RecordsPage = () => {
  return (
    <RecordDetailProvider>
      <Outlet />
    </RecordDetailProvider>
  );
};

export default RecordsPage;
